import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LoggedInProvider } from "./services/context/store";
import ScrollToTop from "./components/Scroll To Top/ScrollToTop";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout/Layout";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Withdrawal from "./pages/Withdrawal";
import Activity from "./pages/Activity";
import Deposit from "./pages/Deposit";
import Profile from "./pages/Profile";
import Referral from "./pages/Referral";
import Subscription from "./pages/Subscription";
import Verify from "./pages/Verify";
import ResetPassword from "./pages/ResetPassword";
import Error from "./components/Error";
import NewPassword from "./pages/NewPassword";
import SignUp from "./pages/Signup";
import Review from "./pages/review";

function App() {
  return (
    <LoggedInProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path={"/client-register"} element={<Register />} />
          <Route path={"/checkout"} element={<SignUp />} />
          <Route path={"/login"} element={<Login />} />
          <Route path={"/"} element={<Layout children={<Dashboard />} />} />
          <Route
            path={"/activity"}
            element={<Layout children={<Activity />} />}
          />
          <Route
            path={"/withdrawal"}
            element={<Layout children={<Withdrawal />} />}
          />
          <Route
            path={"/deposit"}
            element={<Layout children={<Deposit />} />}
          />
          <Route
            path={"/profile"}
            element={<Layout children={<Profile />} />}
          />
          <Route
            path={"/referral"}
            element={<Layout children={<Referral />} />}
          />
          <Route
            path={"/subscription"}
            element={<Layout children={<Subscription />} />}
          />
          <Route path={"/reset/password"} element={<ResetPassword />} />
          <Route
            path={"/verify account"}
            element={<Layout children={<Verify />} />}
          />
          <Route
            path={"/review"}
            element={<Review />}
          />
          <Route path="/confirmation" element={<NewPassword />} />

          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </LoggedInProvider>
  );
}

export default App;
